export default __webpack_public_path__ + "static/media/IMG-20240729-WA0025.3536d34a.jpg";